import React from 'react';
import { SvgIcon } from '@mui/material';

export function Gpt({ isSm }) {
  return isSm ? (
    <SvgIcon sx={{ width: 24, height: 24 }} viewBox="0 0 24 24">
      <g clip-path="url(#clip0_16578_64117)">
        <rect x="-16" y="-16" width="48" height="46" rx="20" fill="#4520AB" />
        <path
          d="M11.8058 14.1375L8.17578 12V8.25C8.17578 6.5925 9.54453 5.25 11.2328 5.25C12.2805 5.25 13.2053 5.7675 13.7565 6.55575"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.1953 17.385C10.4772 17.8063 10.8589 18.1514 11.3064 18.3896C11.7539 18.6277 12.2534 18.7515 12.7603 18.75C14.4478 18.75 15.8173 17.4075 15.8173 15.75V12L12.1153 9.82275"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.0859 13.125V8.75248L13.3949 6.87748C14.8574 6.04873 16.7272 6.53998 17.5717 7.97473C17.8303 8.41213 17.9715 8.90895 17.9815 9.41699C17.9914 9.92502 17.8699 10.427 17.6287 10.8742"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.36541 13.125C6.12407 13.5722 6.00242 14.0741 6.01227 14.5822C6.02213 15.0902 6.16316 15.5871 6.42166 16.0245C7.26616 17.4593 9.13666 17.9505 10.5992 17.1225L13.9082 15.2475L13.9802 11.0505"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.8185 16.2224C16.3297 16.2027 16.8279 16.0553 17.2676 15.7939C17.7074 15.5324 18.0747 15.1651 18.3363 14.7254C19.18 13.2907 18.679 11.4554 17.2173 10.6274L13.9075 8.75244L10.1133 10.8187"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.17488 7.77747C7.66353 7.79712 7.16523 7.94439 6.72535 8.20585C6.28547 8.46732 5.91799 8.83467 5.65638 9.27447C4.81188 10.7092 5.31288 12.5445 6.77538 13.3725L10.0851 15.2475L13.8711 13.185"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16578_64117">
          <rect width="24" height="24" rx="8" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  ) : (
    <SvgIcon sx={{ width: 56, height: 56 }} viewBox="0 0 56 56">
      <g clip-path="url(#clip0_16504_41625)">
        <rect width="56" height="56" rx="20" fill="#4520AB" />
        <path
          d="M27.6565 31.8L21.2031 28V21.3333C21.2031 18.3867 23.6365 16 26.6378 16C28.5005 16 30.1445 16.92 31.1245 18.3213"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24.7969 37.5734C25.298 38.3224 25.9766 38.9359 26.7722 39.3593C27.5678 39.7827 28.4557 40.0028 29.3569 40.0001C32.3569 40.0001 34.7915 37.6134 34.7915 34.6667V28.0001L28.2102 24.1294"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24.5977 30V22.2267L30.4803 18.8934C33.0803 17.42 36.4043 18.2934 37.9057 20.844C38.3654 21.6216 38.6164 22.5049 38.6341 23.408C38.6519 24.3112 38.4359 25.2036 38.007 25.9987"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.9843 30C17.5552 30.795 17.3389 31.6873 17.3565 32.5905C17.374 33.4937 17.6247 34.377 18.0843 35.1547C19.5856 37.7053 22.9109 38.5787 25.5109 37.1067L31.3936 33.7733L31.5216 26.312"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34.7911 35.5067C35.6999 35.4715 36.5855 35.2096 37.3673 34.7448C38.149 34.28 38.8021 33.627 39.2671 32.8454C40.7671 30.2947 39.8764 27.032 37.2778 25.56L31.3938 22.2267L24.6484 25.9"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.2028 20.4933C20.2938 20.5282 19.4079 20.79 18.6259 21.2549C17.8439 21.7197 17.1906 22.3728 16.7255 23.1546C15.2242 25.7053 16.1148 28.968 18.7148 30.44L24.5988 33.7733L31.3295 30.1066"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16504_41625">
          <rect width="56" height="56" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
